<template>
<div>
  <div class="header-container">
      <CountrySwitch class="country--fixed"/>
    <header class="header">
      <div class="header--logo">
<!--
        <a :href=sofomUrl @click="clearStorage">
          <img
            alt="Cumplo"
            src="/static/images/cumplo-tasajusta.png">
        </a>
-->
      </div>
      <nav class="nav">
        <SiteDesktop />
        <LoginDesktop v-if="!isLogged" />
        <LoggedDesktop
          v-else
          :userName="userName"
          :lastLogin="lastLogin" />
      </nav>
      <TheSideNavToggle @toggle="$emit('sidenavToggle')" />
    </header>
  </div>
</div>
</template>

<script>
import CountrySwitch from '@/partials/CountrySwitch'
import CovidBanner from '@/components/Navigation/CovidBanner/CovidBanner'
import TheSideNavToggle from '@/components/Navigation/TheSideNavToggle'
import SiteDesktop from '@/components/Navigation/Menu/Desktop/SiteDesktop'
import LoginDesktop from '@/components/Navigation/Menu/Desktop/LoginDesktop'
import LoggedDesktop from '@/components/Navigation/Menu/Desktop/LoggedDesktop'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

import { mapState } from 'vuex'

Vue.use(VueSweetalert2)

export default {
  name: 'TheHeader',
  components: {
    CountrySwitch,
    CovidBanner,
    TheSideNavToggle,
    SiteDesktop,
    LoginDesktop,
    LoggedDesktop
  },
  created: function () {
    if (this.$store.getters.sessionIsAlive) {
      // aca se abre el modal de horarios, desactivado por solicitud
    }
  },
  computed: mapState({
    isLogged: state => state.alive,
    userName: state => state.userName,
    lastLogin: state => state.lastLogin
  }),
  data () {
    return {
      sofomUrl: `/`
    }
  },
  methods: {
    clearStorage: function () {
      sessionStorage.clear()
    }
  }
}
</script>

<style lang="scss" scoped>

.header {
  background: $green;
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
  box-sizing: border-box;
  padding: 0 20px;
  margin-bottom: 0;
}

.header--logo {
  width: 50%;
  margin-top: .5em;
}

.nav {
  display: none;
}

@media (min-width: 481px) and (max-width: 1023px) {
  .header--logo {
    width: 30%;
  }
}

@media (min-width: 1024px) {

  .header {
    height: 80px;
    position: relative;
  }
  .header--logo {
    width: 13%;
  }

  .nav {
    display: flex;
    position: absolute;
    height: 100%;
    box-sizing: border-box;
    right: 0;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Navigation/TheHeader.vue